import React from "react";
import { Col, Row } from "react-bootstrap";
import Switch from "react-switch";
import Addons from "../Addons";

const Assets = ({
  state,
  setState,
  handleExtraChange,
  extraField,
  activeTab,
  handleSaveField,
}) => {
  const handleToggle = (value, name) => {
    setState((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Furniture:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "furniture_visible")
                    }
                    checked={state.furniture_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "furniture_required")
                    }
                    checked={state.furniture_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Personal Effects:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_visible")
                    }
                    checked={state.personal_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_required")
                    }
                    checked={state.personal_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Artwork:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "artwork_visible")}
                    checked={state.artwork_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "artwork_required")
                    }
                    checked={state.artwork_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Jewellery:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "jewellery_visible")
                    }
                    checked={state.jewellery_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "jewellery_required")
                    }
                    checked={state.jewellery_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Collections:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "collection_visible")
                    }
                    checked={state.collection_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "collection_required")
                    }
                    checked={state.collection_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Guns:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "guns_visible")}
                    checked={state.guns_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "guns_required")}
                    checked={state.guns_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Coins:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "coins_visible")}
                    checked={state.coins_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "coins_required")}
                    checked={state.coins_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Antiques:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "antiques_visible")
                    }
                    checked={state.antiques_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "antiques_required")
                    }
                    checked={state.antiques_required}
                  />
                </div>
              </li>
            </ul>
          </Col>

          {extraField &&
            extraField.length > 0 &&
            extraField.map((item, idx) => {
              return (
                <Col md={6} className="left-name-data my-2" key={idx}>
                  <h6>
                    <strong className="text-capitalize">{item.title}:</strong>
                  </h6>
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="d-flex align-items-center  gap-10">
                      <div className="left d-flex align-items-center gap-10">
                        <strong className="pe-2">Visible</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            ]
                          }
                        />
                      </div>
                      <div className="right d-flex align-items-center gap-10">
                        <strong className="pe-2">Required</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            ]
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </Col>
              );
            })}
        </Row>
      </section>
      <div className="heading-fields-type">
        <h2>Add More Fields in Finance form.</h2>
        <Addons
          handleChange={handleExtraChange}
          data={extraField}
          activeTab={activeTab}
          handleSaveField={handleSaveField}
        />
      </div>
    </div>
  );
};

export default Assets;
